import './tax-settings.css';
import { AVAILABILITY_LABEL, REQUIREMENT_STATUS_ICON, REQUIREMENT_STATUS_LABEL } from './statusLabels';
import type { JurisdictionAvailability, RequirementStatus } from './types';

/** The availability badge shown beside a jurisdiction. It says in words what EPN supports there; Phase 1 has no Certified jurisdiction. */
export function JurisdictionBadge({ availability }: { availability: JurisdictionAvailability }) {
  return (
    <span className={`ts-badge ts-badge--${availability}`} data-testid="jurisdiction-badge">
      {AVAILABILITY_LABEL[availability]}
    </span>
  );
}

/** A requirement status as a chip: words plus a mark, never colour alone. */
export function StatusChip({ status, label }: { status: RequirementStatus; label?: string }) {
  return (
    <span className={`ts-chip ts-chip--${status}`} data-status={status}>
      <span className="ts-chip__icon" aria-hidden="true">
        {REQUIREMENT_STATUS_ICON[status]}
      </span>
      {label ?? REQUIREMENT_STATUS_LABEL[status]}
    </span>
  );
}
